import React, { FC } from 'react'
import { Box, Button, Typography } from '@mui/material'

import {
	TasksHeaderStack,
	TasksHeaderRightActionsBox,
	TasksHeaderAddTaskButtonBox,
	TasksHeaderDeleteTaskButton,
	TasksHeaderRightActionsBtnsBox,
} from './styled'
import TasksHeaderSearch from './TasksHeaderSearch'
import {
	selectAllTask,
	taskDelete,
	unselectAllTasks,
	unselectTask,
} from '../../../../../store/reducers/schedule/tasks/actions'
import TasksAddNewModal from '../TasksAddNew/TasksAddNewModal'
import {
	selectedTasks,
	selectSelectedTasksCount,
	selectTasksList,
} from '../../../../../store/reducers/schedule/tasks/selectors'
import { useTypedSelector } from '../../../../../hooks/useTypedSelector'
import { useDefaultComponentTools } from '../../../../../hooks/useDefaultComponentTools'

const TasksAddNewTaskForm = React.lazy(
	() =>
		import(
			/* webpackChunkName: "tasks_add_new_task_form" */ '../TasksAddNew/TasksAddNewTaskForm'
		)
)

const TasksHeader: FC = () => {
	const { dispatch, alert } = useDefaultComponentTools()

	const totalSelectedTasksCount = useTypedSelector(selectSelectedTasksCount)
	const selectedTasksList = useTypedSelector(selectedTasks)

	const totalTasksCount = useTypedSelector(selectTasksList).length

	const handelDeleteTask = async (): Promise<void> => {
		try {
			await dispatch(taskDelete(selectedTasksList[0]))
			await dispatch(unselectTask(selectedTasksList[0]))
			alert.success(`Task deleted`)
		} catch (e: any) {
			'message' in e && alert.error(e.message)
		}
	}
	const handleSelectAllTasks = (): void => {
		dispatch(selectAllTask())
	}
	const handleUnselectAllTasks = (): void => {
		dispatch(unselectAllTasks())
	}

	return (
		<TasksHeaderStack direction='row' spacing={2}>
			<Box display={'flex'} alignItems={'center'} flexWrap={'wrap'}>
				<Typography variant={'h3'} component={'h1'} fontSize={'2.4rem'}>
					Tasks
				</Typography>

				<Typography variant='subtitle2' pl={4}>
					{totalTasksCount} total tasks / {totalSelectedTasksCount}{' '}
					selected
				</Typography>

				<Box>
					<Button onClick={handleSelectAllTasks} variant='text'>
						Select all
					</Button>

					<Button onClick={handleUnselectAllTasks} variant='text'>
						Reset selection
					</Button>
				</Box>
			</Box>

			<TasksHeaderRightActionsBox>
				<TasksHeaderSearch />

				<TasksHeaderRightActionsBtnsBox>
					<TasksHeaderDeleteTaskButton
						variant='contained'
						color={'secondary'}
						onClick={handelDeleteTask}
						disabled={!totalSelectedTasksCount}
					>
						Delete Tasks
					</TasksHeaderDeleteTaskButton>

					<TasksHeaderAddTaskButtonBox>
						<TasksAddNewModal>
							<TasksAddNewTaskForm />
						</TasksAddNewModal>
					</TasksHeaderAddTaskButtonBox>
				</TasksHeaderRightActionsBtnsBox>
			</TasksHeaderRightActionsBox>
		</TasksHeaderStack>
	)
}
export default TasksHeader
